<template>
    <dash
        icon="fa fa-dollar"
        titulo="PAGAMENTOS DESPESA"
        subTitulo="DEMANDANTE"
        @click.native="$router.push({ name: 'DespesasGerais_Demandantes_Pagamentos' })"
    ></dash>
</template>

<script>
import Dash from '@/shared/components/DashComponent'

export default {
    components: {
        Dash
    },

    data() {
        return {}
    }
}
</script>